<template>
  <Card theme="border" class="contract-card" v-bind="$attrs" v-on="$listeners">
    <template #default>
      <div class="contract-card__header">
        <div class="contract-card__type">{{ $tc(getTypeLabel(value.type)) }}</div>
        <StatusBadge :value="value.status" />
      </div>
      <div class="contract-card__title">{{ title }}</div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import StatusBadge from '@/components/Contract/StatusBadge'
import Badge from '@/components/Badge'

export default {
  props: {
    value: Object,
  },
  computed: {
    title() {
      if (this.value.type === 'custom') return this.value.title
      return this.value.title.replace(this.$tc(this.getTypeLabel(this.value.type)) + ' - ', '')
    },
  },
  methods: {
    getTypeLabel(type) {
      switch (type) {
        case 'purchase':
        case 'bid':
        case 'shop':
          return `${type}Contract`
        case 'shop-partial':
          return 'shopContract'
        default:
          return 'contract'
      }
    },
  },
  components: {
    Card,
    Badge,
    StatusBadge,
  },
}
</script>

<style lang="scss">
.contract-card {
  background-color: transparent;

  &__header {
    display: flex;
    justify-content: space-between;

    gap: 0.5rem;
  }

  &__type {
    font-size: 0.7em;
    opacity: 0.6;
    letter-spacing: 0.2px;
  }

  &__title {
    font-weight: bold;
  }

  & > .card__content {
    padding: 0.75rem;
  }
}
</style>
